import { IPreSelectHistoryDetails } from '@nkr/models/index';
import { CsvExportParams, FirstDataRenderedEvent, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';
import CenterDetailsGrid from './center-details-grid';

interface IProps {
    show: boolean,
    startDate: string,
    endDate: string,
    reportDetails: IPreSelectHistoryDetails[],
    average: number,
    onClose: () => void
}

const CenterDetails = (props: IProps) => {
    const [gridApi, setGridApi] = useState<GridApi>(null);

    const onGridReady = (e: GridReadyEvent) => {
        setGridApi(e.api);

        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const handleExportDetails = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'preselect-history-details.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                return params.value != null ? params.value.toString() : '';
            }
        };

        gridApi.exportDataAsCsv(params);
    }

    const centerAlias = props.reportDetails.length > 0 ? props.reportDetails[0].centerAlias : '';

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onClose}>
            <Modal.Header closeButton>
                {centerAlias} Preselects {props.startDate} - {props.endDate}
            </Modal.Header>
            <Modal.Body>
                <CenterDetailsGrid
                    data={props.reportDetails}
                    height='350px'
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered} />

                <div>
                    <span style={{ color: '#0000ff' }}>Average (ignoring first instance of lowest score marked above) <b>{props.average}%</b></span> &emsp;&emsp;&emsp;&emsp;
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleExportDetails}>Export CSV</Button>
                <Button bsStyle='primary' onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CenterDetails;